module.exports = __webpack_public_path__ + "static/media/4.8995a6ca.png";